import React from "react";
export function ProductListViewHeader() {
    return (React.createElement("div", { className: "col-span-12 grid grid-cols-subgrid border-b border-gray pb-4 text-primary font-semibold" },
        React.createElement("div", { className: "col-span-2" },
            React.createElement("div", null, "Image")),
        React.createElement("div", { className: "col-span-3" },
            React.createElement("div", null, "Title")),
        React.createElement("div", { className: "col-span-4 md:col-span-2 text-right" },
            React.createElement("div", null, "Price")),
        React.createElement("div", { className: "col-span-3 md:col-span-5 text-right" }, "Actions")));
}
